import * as t from 'io-ts';

export const UserRoleNameSchema = t.keyof({
    ROLE_BONITER: null,
    ROLE_ADMIN: null,
});

export type UserRoleName = t.TypeOf<typeof UserRoleNameSchema>;
